import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

export default function AuditLogs({ scope = "super" }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const path = scope === "super" ? "/super-admin/audit-logs?limit=200" : "/school/audit-logs?limit=200";
        const { data } = await api.get(path);
        setLogs(data);
      } catch (e) {
        setError(formatApiError(e));
      }
      setLoading(false);
    })();
  }, [scope]);

  return (
    <div className="space-y-6" data-testid="audit-logs-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-slate-500">Audit</div>
        <h1 className="text-3xl font-bold tracking-tight text-slate-900 font-heading mt-1">
          Audit trail <span className="text-slate-400 font-normal">({logs.length})</span>
        </h1>
        <p className="text-sm text-slate-600 mt-1">
          Tamper-evident timeline of every sensitive action.
        </p>
      </div>

      <div className="border border-slate-200 bg-white rounded-lg overflow-x-auto">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-slate-50">
            <tr className="text-[11px] uppercase tracking-wider text-slate-500">
              <th className="text-left font-semibold px-4 py-3">Timestamp</th>
              <th className="text-left font-semibold px-4 py-3">Action</th>
              <th className="text-left font-semibold px-4 py-3">User</th>
              <th className="text-left font-semibold px-4 py-3">School</th>
              <th className="text-left font-semibold px-4 py-3">IP</th>
              <th className="text-left font-semibold px-4 py-3">Metadata</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {loading ? (
              <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-500">Loading…</td></tr>
            ) : error ? (
              <tr><td colSpan={6} className="px-4 py-10 text-center text-red-600">{error}</td></tr>
            ) : logs.length === 0 ? (
              <tr><td colSpan={6} className="px-4 py-10 text-center text-slate-500">No audit events yet.</td></tr>
            ) : (
              logs.map((l) => (
                <tr key={l.id} className="hover:bg-slate-50 transition-colors">
                  <td className="px-4 py-3 text-xs text-slate-600 whitespace-nowrap">
                    {new Date(l.timestamp).toLocaleString()}
                  </td>
                  <td className="px-4 py-3">
                    <span className="font-mono text-xs bg-slate-100 px-1.5 py-0.5 rounded text-slate-800">
                      {l.action}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-slate-700">{l.user_email || "—"}</td>
                  <td className="px-4 py-3 text-xs font-mono text-slate-500">{l.school_id || "—"}</td>
                  <td className="px-4 py-3 text-xs font-mono text-slate-500">{l.ip_address || "—"}</td>
                  <td className="px-4 py-3 text-xs text-slate-600 max-w-md truncate">
                    {l.metadata && Object.keys(l.metadata).length > 0 ? JSON.stringify(l.metadata) : "—"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
